import timeStampToDate from '@/helpers/timeStampToDate';
import { getColor } from '@/helpers/utils';
import React, { useState } from 'react';
import { MdCheck, MdContentCopy, MdOutlineOpenInNew } from 'react-icons/md';
import { errorMessage } from '@/utils/toast';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';

export const googleResultsHistoryColumnConfig = columns => {
  let mapCoumns = [
    {
      field: 'rank',
      type: 'number',
      title: 'رتبه',
      width: 70,
      pinned: 'right'
    }
  ];

  columns?.map(item => {
    mapCoumns.push({
      field: item,
      type: 'string',
      suppressHeaderMenuButton: true,
      sortable: false,
      width: 200,
      cellStyle: params => {
        return {
          color: params.value.is_competitor
            ? getColor('danger')
            : params.value.site_itself
              ? getColor('success')
              : null
          // color: params.value.is_competitor
          //   ? getColor('gray-100')
          //   : params.value.site_itself
          //     ? getColor('gray-100')
          //     : null
        };
      },
      title: timeStampToDate(Number(item)).slice(8).toPersianDigit(),
      searchable: true,
      cellRenderer: params => {
        const [copied, setCopied] = useState(false);

        return (
          params.value.domain !== '' && (
            <ChildrensTooltip
              placement="top"
              delayToRemove={0}
              showOnHover={false}
              html={
                <div className="d-flex flex-column justify-content-start align-items-start">
                  <div className="text-start">عنوان سئو این سایت در گوگل:</div>
                  <div className="text-start fw-bold">
                    {' '}
                    {params.value.title}
                  </div>
                  <div className="text-start">نشانی:</div>
                  <div dir="ltr" className="text-end fw-bold">
                    {params.value.url}
                  </div>
                </div>
              }
            >
              <>
                <style>
                  {`
              .cellContainer:hover .googleResultHistoryCell {
                visibility: visible;
              }
              .googleResultHistoryCell {
                visibility: hidden;
              }
            `}
                </style>
                <div className="d-flex gap-1 align-items-center cellContainer">
                  <div className="googleResultHistoryCell">
                    {copied ? (
                      <MdCheck size={18} />
                    ) : (
                      <MdContentCopy
                        title="کپی پیوند"
                        onClick={e => {
                          navigator.clipboard
                            .writeText(params.value.url)
                            .then(() => {
                              setCopied(true);
                              setTimeout(() => {
                                setCopied(false);
                              }, 3000);
                            });
                        }}
                        className="cursor-pointer little-icon"
                        style={{ paddingLeft: '3px' }}
                        size={18}
                      />
                    )}
                    <MdOutlineOpenInNew
                      title="بازکردن پیوند"
                      onClick={() => {
                        try {
                          window.open(decodeURI(params.value.url), '_blank');
                        } catch (error) {
                          // Handle the error here
                          errorMessage('پیوند قابل بازکردن نمیباشد.');
                          console.error('خطا در بازکردن پیوند:', error);
                        }
                      }}
                      className="cursor-pointer little-icon"
                      style={{ paddingLeft: '3px' }}
                      size={18}
                    />
                  </div>
                  {params.value.domain}
                </div>
              </>
            </ChildrensTooltip>
          )
        );
      }
    });
  });
  return mapCoumns;
};
